import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { LP_UI_CONFIG } from '../core/tokens';
import { StorageService } from '../services/storage.service';
import { AdditionalInfo, AdditionalInfoType } from '../models/classes/additionalinfo';

export interface AdditionalInfoTypesResponse {
  infoTypes: AdditionalInfoType[];
  defaultFields: AdditionalInfo[];
}

@Injectable({ providedIn: 'root' })
export class AdditionalInfoApi {
  private readonly cfg = inject(LP_UI_CONFIG);
  private http = inject(HttpClient);
  private storage = inject(StorageService);

  private get headers() {
    return {
      Authorization: 'Bearer ' + this.storage.token(),
    };
  }

  /**
   * Get additional info for a specific object
   */
  async getAdditionalInfo(objectID: number): Promise<AdditionalInfo[]> {
    return firstValueFrom(
      this.http.get<AdditionalInfo[]>(`${this.cfg.host}api/additional_info/${objectID}`, {
        headers: this.headers,
      })
    );
  }

  /**
   * Get additional info types and default fields
   */
  async getAdditionalInfoTypes(): Promise<AdditionalInfoTypesResponse> {
    return firstValueFrom(
      this.http.get<AdditionalInfoTypesResponse>(`${this.cfg.host}api/additional_info_types/`, {
        headers: this.headers,
      })
    );
  }

  /**
   * Update additional info values
   */
  async updateAdditionalInfo(addInfoValues: AdditionalInfo[]): Promise<AdditionalInfo[]> {
    // Stringify unit property for each item (matching Angular 12 behavior)
    const newAddInfoValues = addInfoValues.map((item) => ({
      ...item,
      unit: item.unit ? JSON.stringify(item.unit) : item.unit,
    }));

    return firstValueFrom(
      this.http.post<AdditionalInfo[]>(
        `${this.cfg.host}api/update_additional_info/`,
        { additionalInfo: newAddInfoValues },
        { headers: this.headers }
      )
    );
  }
}
